import React from "react";
import styled from "styled-components";

export default function Prices2() {
    return (
        <Container>
            {/* <ServiceModal className={props.modalClass}>

                <PopUpModal className="modal">
                    <h2 style={{marginBottom: "1rem", color: gray}}>Are you sure you want to delete this price item?</h2>
                    <PricesDiv>
                        <span className="btn-mask">Confirm Booking</span>
                        <button>Confirm Booking</button>
                    </PricesDiv>
                    
                </PopUpModal>

            </ServiceModal> */}
        </Container>
    )
}

const Container = styled.div`
    flex: 1;
`

